import { render } from "./ClientsEditView.vue?vue&type=template&id=0d9bb1bd"
import script from "./ClientsEditView.vue?vue&type=script&lang=js"
export * from "./ClientsEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__